export enum SkirtingType {
    None,
    FourInch,
    SixInch
}